import { createBrowserRouter } from "react-router";
import { RootLayout } from "./components/RootLayout";
import { Dashboard } from "./components/Dashboard";
import { Vehicles } from "./components/Vehicles";
import { Maintenance } from "./components/Maintenance";
import { MaintenanceSchedulePage } from "./components/MaintenanceSchedulePage";
import { AccountPage } from "./components/account/AccountPage";
import { LoginPage } from "./components/auth/LoginPage";
import { SignupPage } from "./components/auth/SignupPage";
import { ForgotPasswordPage } from "./components/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "./components/auth/ResetPasswordPage";
import { ProtectedRoute } from "./components/ProtectedRoute";

export const router = createBrowserRouter([
  {
    path: "/login",
    Component: LoginPage,
  },
  {
    path: "/signup",
    Component: SignupPage,
  },
  {
    path: "/forgot-password",
    Component: ForgotPasswordPage,
  },
  {
    path: "/reset-password",
    Component: ResetPasswordPage,
  },
  {
    path: "/",
    Component: ProtectedRoute,
    children: [
      {
        Component: RootLayout,
        children: [
          { index: true, Component: Dashboard },
          { path: "vehicles", Component: Vehicles },
          { path: "maintenance", Component: Maintenance },
          { path: "schedules", Component: MaintenanceSchedulePage },
          { path: "account", Component: AccountPage },
        ],
      },
    ],
  },
]);
